import React from 'react';
import TextComponent, {
  TextFieldGlimmer as TextFieldGlimmerComponent,
} from '../../components/fields/text/Text';
import type { TextProps as TextComponentProps } from '../../components/fields/text/Text';
import '../../../../stylesheets/components/textField.module.scss';
import editStyles from '../../../../stylesheets/components/edit.module.scss';
import glimmerStyles from '../../../../stylesheets/components/glimmer.module.scss';
import classNames from 'classnames';

type TextAppearance = 'outlined' | 'compact';

interface TenantTextProps extends Omit<
  TextComponentProps,
  'editClassNames' | 'variant'
> {
  appearance?: TextAppearance;
  className?: string;
}

const Text = ({
  field,
  mode,
  onChange,
  onKeyDown,
  testClass,
  errors,
  appearance = 'outlined',
  className,
}: TenantTextProps) => {
  const variant = appearance === 'compact' ? 'standard' : 'outlined';

  return (
    <TextComponent
      field={field}
      mode={mode}
      variant={variant}
      onChange={onChange}
      onKeyDown={onKeyDown}
      editClassNames={className || editStyles.pmEdit}
      testClass={testClass}
      errors={errors}
    />
  );
};

export const TextFieldGlimmer = () => {
  return (
    <TextFieldGlimmerComponent
      editClassNames={editStyles.pmEdit}
      glimmerClassNames={classNames(
        glimmerStyles.textField,
        glimmerStyles.glimmerElement
      )}
    />
  );
};

export default Text;
